export default "__VITE_ASSET__CtkTmtxy__"